import React, { useEffect, useState } from "react";
import { Box, Text } from "grommet";
import { ReportHeader } from "../../components/QuizResultsComponents/ReportHeaeder";
import { LearningPath } from "../../components/QuizResultsComponents/LearningPath";
// import { ProgressTracking } from "../../components/QuizResultsComponents/ProgressTracking";
// import { ManagerialInsights } from "../../components/QuizResultsComponents/ManagerialInsights";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { quizResultsData as sampleData } from "../../components/QuizResultsComponents/sampleQuizData";
import { useNavigate } from "react-router-dom";
import { LinkPrevious } from "grommet-icons";
import { ProductsAssessment } from "../../components/QuizResultsComponents/ProductsAssessment";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import { DigitalLearningPath } from "../../components/QuizResultsComponents/DigitalLearningPath";
import { DedicatedLearningButton } from "../../components/Buttons/DedicatedLearning";
import UserAssessmentDetails from "../../components/QuizResultsComponents/AssessmentHistoryByTopics";
const ManagerQuizResultsPage = () => {
  const { user_id, assessment_id } = useParams();
  const [name, setName] = useState();
  const [isLearningPathVisible, setIsLearningPathVisible] = useState(false);
  const [selectedSkillId, setSelectedSkillId] = useState(null);

  const [quizResultsData, setQuizResultsData] = useState(sampleData);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        axios
          .get(`${API_URL}/user/getUserNameById/${user_id}`)
          .then((response) => {
            setName(response.data.name);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleShowLearningPath = (skillId) => {
    setSelectedSkillId(skillId);
    setIsLearningPathVisible(true);
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />

        <Box
          align="center"
          pad={{ horizontal: "medium", vertical: "medium" }}
          margin={{ horizontal: "small", vertical: "medium" }}
        >
          <Box alignSelf="start">
            <LinkPrevious
              onClick={() => {
                navigate(-1);
              }}
              size="large"
              color="brand"
            />
          </Box>
          <Box alignSelf="center" alignContent="center" align="center">
            <Text size="large" weight="bold" margin={{ bottom: "small" }}>
              Recommendations report
            </Text>
            <Text size="medium" margin={{ bottom: "medium" }}>
              Here are the recommendations for the user based on their
              performance in the skill assessment.
            </Text>
          </Box>

          <Box width="100%" pad={{ horizontal: "medium" }}>
            <Box border={{ color: "brand", size: "small" }}>
              {/* <ReportHeader name={name} date={quizResultsData.date} /> */}

              <ProductsAssessment
                user_id={user_id}
                assessment_id={assessment_id}
                onShowLearningPath={handleShowLearningPath}
              />
              {isLearningPathVisible && (
                <Box background="black" pad="small">
                  <LearningPath
                    user_id={user_id}
                    skills_id={selectedSkillId}
                    assessment_id={assessment_id}
                    onClose={() => setIsLearningPathVisible(false)}
                  />
                </Box>
              )}
              <Box
                direction="row"
                pad="medium"
                align="center" // Align the items to the center
                alignContent="center" // Align the content to the center
                alignSelf="center" // Align the box to the center
              >
                {/* <Text size="large" weight="bold" margin={{ bottom: "medium" }}>
                  {" "}
                  Need dedicated learning?{" "}
                </Text> */}
                {/* <DedicatedLearningButton user_id={user_id} /> */}
              </Box>
              {/* <UserAssessmentDetails user_id={user_id} /> */}
              <DigitalLearningPath
                user_id={user_id}
                assessment_id={assessment_id}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default ManagerQuizResultsPage;
